import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faFilter, faHeart, faSort } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from 'react-router-dom';
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';
import { api } from "../../Constant";
import axios from 'axios';
import Popup from '../RegisterScreen/Popup';
import lovebg from "../../assets/images/love-bg.png";
const CategoryPage = () => {
   const params = useParams();
const categoryid = params.id; 
    const [category, setCategory] = useState("");
    const [products, setProducts] = useState([]);
    const [popupVisible, setPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [isWishlistActive, setIsWishlistActive] = useState({});
    const [username, setUsername] = useState("");
    const [type, setType] = useState('')
    const [userid, setUserid] = useState("")
    const [sortId, setSortId] = useState(null);
    const [productCount, setProductCount] = useState(0);
    const navigate = useNavigate('')
    const [size, setSize] = useState([]);
    const [pattern, setPattern] = useState([]);
    const [categoryfill, setCategoryfill] = useState([])
    const [gender, setGender] = useState([])
    const handleSortChange = (event) => {
        setSortId(event.target.value);
    };

    useEffect(() => {
        axios.post(api + `category_product_list`, { category_id: categoryid })
            .then((response) => {
                if (response.data.success === "true") {
                    setCategory(response.data.category_name); // Store the category name
                    setProducts(response.data.product); // Store the list of products
                    setProductCount(response.data.product.length)
                } else {
                    console.log('No products found');
                }
            })
            .catch((error) => {
                console.log('Error:', error);
            });
    }, [categoryid]);

    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const sortdrop = () => {
        setDropdownVisible(!isDropdownVisible);
    };

    const [isFilterVisible, setFilterVisible] = useState(false);
    const filter = () => {
        setFilterVisible(!isFilterVisible);
    };
    const cancelFilter = () => {
        setFilterVisible(false);
    };
    const [openSection, setOpenSection] = useState(null); // Single state for managing which section is open
    const toggleSection = (section) => {
        setOpenSection(openSection === section ? null : section);
    };
    useEffect(() => {
        const storedUsername = localStorage.getItem('userName');
        const storedUserid = localStorage.getItem('userId');
        setUsername(storedUsername || "");
        setUserid(storedUserid)
    }, []);


    const whishlistClick = (productId) => {
        if (!username) {
            setPopupMessage("Please log in to use the wishlist feature.");
            setType("error");
            setPopupVisible(true);
            return;
        }

        const apiEndpoint = isWishlistActive[productId] ? "remove_wishlist" : "add_wishlist";
        const successMessage = isWishlistActive[productId]
            ? "Product removed successfully from Wishlist."
            : "Wishlist added successfully.";

        axios.post(api + apiEndpoint, {
            user_id: userid,
            product_id: productId,
        })
            .then((response) => {
                if (response.data.success === "true") {
                    setPopupMessage(successMessage);
                    setType("success");
                    setIsWishlistActive((prevState) => ({
                        ...prevState,
                        [productId]: !prevState[productId] // Toggle wishlist status
                    }));
                } else {
                    setPopupMessage("Failed to update wishlist.");
                    setType("error");
                }
                setPopupVisible(true);
            })
            .catch((error) => {
                setPopupMessage("An error occurred while updating the wishlist.");
                setType("error");
                setPopupVisible(true);
            });
    };

    useEffect(() => {
        const storedUsername = localStorage.getItem('userName');
        const storeUserid = localStorage.getItem('userId');
        setUsername(storedUsername || "");
        setUserid(storeUserid || "");

        // Fetch wishlist on mount
        if (storeUserid) {
            axios.post(api + "wishlist", { user_id: storeUserid })
                .then((response) => {
                    if (response.data.success === "true") {
                        const wishlistProducts = response.data.product;
                        // Create an object with product IDs as keys and set them as active in wishlist
                        const wishlistState = wishlistProducts.reduce((acc, product) => {
                            acc[product.product_id] = true;
                            return acc;
                        }, {});
                        setIsWishlistActive(wishlistState);
                    } else {
                        console.log("No products found in wishlist");
                    }
                })
                .catch((error) => {
                    console.log("Error fetching wishlist:", error);
                });
        }
    }, []);

    const handleClosePopup = () => {
        setPopupVisible(false);
    };
    const productdetailmove = (product_id) => {
        navigate(`/product-detail/${product_id}`)
    }
    useEffect(() => {
        axios.post(api + "size")
            .then((response) => {
                if (response.data.success === "true") {  // Check if the API call was successful
                    setSize(response.data.sizes);  // Access the `category` array from response.data
                } else {
                    console.log('No categories found');
                }
            })
            .catch((error) => {
                console.log('Error:', error);
            });

        axios.post(api + "pattern")
            .then((response) => {
                if (response.data.success === "true") {
                    setPattern(response.data.patterns);
                } else {
                    console.log('No categories found');
                }
            })
            .catch((error) => {
                console.log('Error:', error);
            });

        axios.post(api + "category_list")
            .then((response) => {
                if (response.data.success === "true") {
                    setCategoryfill(response.data.category);
                } else {
                    console.log('No categories found');
                }
            })
            .catch((error) => {
                console.log('Error:', error);
            });


        axios.post(api + "gender_list")
            .then((response) => {
                if (response.data.success === "true") {
                    setGender(response.data.state);
                } else {
                    console.log('No categories found');
                }
            })
            .catch((error) => {
                console.log('Error:', error);
            });
    }, []);

    useEffect(() => {
        if (sortId) {
            axios.post(api + `sort_filter`, { category_id: categoryid, sort_id: sortId })
                .then((response) => {
                    if (response.data.success === "true") {
                        setProducts(response.data.product);
                        setProductCount(response.data.product.length);
                    } else {
                        console.log('No products found');
                    }
                })
                .catch((error) => {
                    console.log('Error:', error);
                });
        }
    }, [sortId, categoryid]);

    const [selectedCategories, setSelectedCategories] = useState([]); // Array for categories
    const [selectedSize, setSelectedSize] = useState("");
    const [selectedPattern, setSelectedPattern] = useState("");
    const [selectedGender, setSelectedGender] = useState("");

    // Handle the checkbox change
    // Handle the checkbox change
    const handleCategoryChange = (event) => {
        const categoryId = parseInt(event.target.value, 10);
        setSelectedCategories((prevSelectedCategories) =>
            prevSelectedCategories.includes(categoryId)
                ? prevSelectedCategories.filter(item => item !== categoryId)
                : [...prevSelectedCategories, categoryId]
        );
    };

    // Handle other filter changes
    const handleSizeChange = (event) => setSelectedSize(event.target.value);
    const handlePatternChange = (event) => setSelectedPattern(event.target.value);
    const handleGenderChange = (event) => setSelectedGender(event.target.value);
    // Fetch filtered products
    useEffect(() => {
        if (selectedCategories.length > 0 || selectedSize || selectedPattern || selectedGender) {
            axios
                .post(api + 'filter', {
                    category_id: selectedCategories, // Array of categories
                    size_id: selectedSize, // Single size value
                    print_id: selectedPattern, // Single pattern value
                    gender_id: selectedGender, // Single gender value
                })
                .then((response) => {
                    if (response.data.success === "true") {
                        setProducts(response.data.product);
                        setProductCount(response.data.product.length);
                    } else {
                        console.log("No products found");
                    }
                })
                .catch((error) => {
                    console.error("Error fetching products:", error);
                });
        }
    }, [selectedCategories, selectedSize, selectedPattern, selectedGender]);

    return (
        <>
            <div className='caytegory-bg pt-5 pb-5'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-4 col-sm-5 filter-main category-head'>
                            <div className='filterbtn'>
                                <button onClick={filter}>
                                    <FontAwesomeIcon icon={faFilter} />
                                    Filter
                                </button>
                                <h6>{productCount} Products</h6>
                            </div>
                            {isFilterVisible && (
                                <div className='filter-dropdown'>
                                    <div className='filter-content'>
                                        <div className='filter-wrap'>
                                            <h4>Filter</h4>
                                            <button onClick={cancelFilter} className="cancel-btn">
                                                <FontAwesomeIcon icon={faXmark} />
                                            </button>
                                        </div>
                                        <div className="category-accordion">
                                            {/* Category Section */}
                                            <div className="dropdown-toogle" onClick={() => toggleSection("category")}>
                                                <h5 style={{ cursor: "pointer", color: "#6f716d" }}>Category</h5>
                                                <FontAwesomeIcon icon={openSection === "category" ? faAngleUp : faAngleDown} />
                                            </div>
                                            {openSection === "category" && (
                                                <div className="filter-options">
                                                    {categoryfill.map((item) => (
                                                        <>
                                                            <label key={item.category_id}>
                                                                <input
                                                                    type="checkbox"
                                                                    name="filter1"
                                                                    value={item.category_id}
                                                                    checked={selectedCategories.includes(item.category_id)}
                                                                    onChange={handleCategoryChange}
                                                                />
                                                                {item.category_name}
                                                            </label>
                                                            <br />
                                                        </>
                                                    ))}
                                                </div>
                                            )}
                                            {/* Size Section */}
                                            <div className="dropdown-toogle" onClick={() => toggleSection("size")}>
                                                <h5 style={{ cursor: "pointer", color: "#6f716d" }}>Size</h5>
                                                <FontAwesomeIcon icon={openSection === "size" ? faAngleUp : faAngleDown} />
                                            </div>
                                            {openSection === "size" && (
                                                <div className="filter-options">
                                                    {size.map((item) => (
                                                        <>
                                                            <label key={item.size}>
                                                                <input
                                                                    type="radio"
                                                                    name="size"
                                                                    value={item.size}
                                                                    onChange={handleSizeChange}
                                                                />
                                                                {item.size}
                                                            </label>
                                                            <br />
                                                        </>
                                                    ))}  
                                                </div>
                                            )}
                                            {/* Gender Section */}
                                            <div className="dropdown-toogle" onClick={() => toggleSection("gender")}>
                                                <h5 style={{ cursor: "pointer", color: "#6f716d" }}>Gender</h5>
                                                <FontAwesomeIcon icon={openSection === "gender" ? faAngleUp : faAngleDown} />
                                            </div>
                                            {openSection === "gender" && (
                                                <div className="filter-options">
                                                    {gender.map((item) => (
                                                        <>
                                                            <label key={item.gender_name}>
                                                                <input
                                                                    type="radio"
                                                                    name="gender"
                                                                    value={item.gender_name}
                                                                    onChange={handleGenderChange}
                                                                />
                                                                {item.gender_name}
                                                            </label>
                                                            <br />
                                                        </>
                                                    ))}
                                                </div>
                                            )}
                                            {/* Print Section */}
                                            <div className="dropdown-toogle" onClick={() => toggleSection("print")}>
                                                <h5 style={{ cursor: "pointer", color: "#6f716d" }}>Print</h5>
                                                <FontAwesomeIcon icon={openSection === "print" ? faAngleUp : faAngleDown} />
                                            </div>
                                            {openSection === "print" && (
                                                <div className="filter-options">
                                                    {pattern.map((item) => (
                                                        <>
                                                            <label key={item.pattern}>
                                                                <input
                                                                    type="radio"
                                                                    name="print"
                                                                    value={item.pattern}
                                                                    onChange={handlePatternChange}
                                                                />
                                                                {item.pattern}
                                                            </label>
                                                            <br />
                                                        </>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="col-lg-4 col-sm-3 category-title">
                            {selectedCategories && selectedCategories.length > 0 ? (
                                // Show the category if selectedCategories is not empty
                                <h1></h1>
                            ) : (
                                // Show fallback message if no category is selected
                                <h1>{category}</h1>
                            )}
                        </div>
                        <div className='col-lg-4 col-sm-4 sort-category-page category-head'>
                            <div className='filterbtn-one'>
                                <button onClick={sortdrop}>
                                    <FontAwesomeIcon icon={faSort} />
                                    Sort
                                </button>
                            </div>
                            {isDropdownVisible && (
                                <div className='sort-dropdown'>
                                    <div className="triangle-up"></div>
                                    <div className='sort-radio'>
                                        <input type="radio" id="newArrivals" name="sortOption" value="1" onChange={handleSortChange} />
                                        <label htmlFor="newArrivals">New Arrivals</label> <br />
                                        <input type="radio" id="highToLow" name="sortOption" value="2" onChange={handleSortChange} />
                                        <label htmlFor="highToLow">Price: High to Low</label><br />
                                        <input type="radio" id="lowToHigh" name="sortOption" value="3" onChange={handleSortChange} />
                                        <label htmlFor="lowToHigh">Price: Low to High</label>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='row category-main-top'>
                       
{products.map((item) => {
    return (
        <div className='col-lg-3 col-sm-6 maincategory' key={item.product_id}>
            <div
                className='category-card'
                style={{
                    backgroundImage: `url(${lovebg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    borderRadius: '10px',
                    padding: '15px',
                    position: 'relative'
                }}
            >
                <img
                    src={item.product_image}
                    alt='imge1'
                    style={{
                        width: '100%',
                        borderRadius: '10px',
                        objectFit: 'cover'
                    }}
                />

                <FontAwesomeIcon
                    icon={faHeart}
                    onClick={() => whishlistClick(item.product_id)}
                    style={{
                        cursor: 'pointer',
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        color:
                            username && isWishlistActive[item.product_id]
                                ? "#92ad69"
                                : "rgb(191, 191, 191)"
                    }}
                />
            </div>

          <div className='category-cardbottom'>
  <p>{item.name}</p>

  {Number(item.discount_price) > 0 ? (
    <h6>
      ₹ {item.discount_price}
      <span
        style={{
          textDecoration: 'line-through',
          marginLeft: '10px',
          color: 'gray',
          fontSize: '14px'
        }}
      >
        ₹ {item.price}
      </span>
    </h6>
  ) : (
    <h6>₹ {item.price}</h6>
  )}
</div>


            <div
                className='category-cardbottomone'
                onClick={() => productdetailmove(item.product_id)}
            >
                <a>Shop now</a>
            </div>
        </div>
    );
})}

                    </div>
                    {popupVisible && (
                        <Popup
                            message={popupMessage}
                            title="Notice"
                            type={type}
                            onClose={handleClosePopup}
                        />
                    )}
                </div>
            </div>
        </>
    )
}

export default CategoryPage;